document.addEventListener('DOMContentLoaded', function (event) {
  // Get the header
  const header = document.querySelector('.header-group');
  const table = document.querySelector('.table-body');
  if (table) {
    const breakpoint = window.matchMedia('(min-width:768px)');
    // Add the sticky class to the header when you reach its scroll position.
    // Remove "sticky" when you leave the scroll position
    function showStickyHeader() {
      let start = table.offsetTop;
      let end = start + table.offsetHeight - 80;
      if ((window.pageYOffset < end) && (window.pageYOffset > start)) {
        document.querySelector('.sticky-header').classList.add('reveal');
        document.querySelector('header').style.display = 'none';
      } else {
        document.querySelector('header').style.display = '';
        document.querySelector('.sticky-header').classList.remove('reveal');
      }
    }

    // When the user scrolls the page, execute myFunction
    window.onscroll = function () { showStickyHeader(); };
  }
});
